exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.login-language[data-v-2b46c3df] {\n  width: 100px;\n  float: right;\n  margin-top: -10px;\n}\n.login-card-body[data-v-2b46c3df] {\n  padding-top: 0px !important;\n  margin-top: -20px !important;\n}\n.login-logo[data-v-2b46c3df] {\n  width: 85%;\n  margin-bottom: 20px;\n}\n.login-copyright[data-v-2b46c3df] {\n  margin-top: 40px;\n  margin-bottom: -30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b46c3df","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/Login.vue
// module id = 1306
// module chunks = 0